module.exports = __webpack_public_path__ + "static/media/dmitriy.18d5b643.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dmitriy.png
// module id = 114
// module chunks = 0